<template>
	<ui-modal @toggle="$emit('toggle')">
		<div class="flex flex-col gap-2" v-if="!loading">
			<ui-title textSize="big" textPosition="left" class="lg:col-span-2 text-slate-700">
				<template v-slot:text>
					<p>Filtres</p>
				</template>
			</ui-title>
			<form @submit.prevent="doSearch" class="flex flex-col lg:grid lg:grid-cols-2 gap-2">
				<form-validation-errors class="lg:col-span-2"></form-validation-errors>
				<!-- NAME -->
				<form-input placeholder="Prénom, NOM" v-model="form.name" @keyup.enter="doSearch"> </form-input>
				<!-- ADRESSE -->
				<form-input placeholder="Code postal, ville" v-model="form.address" @keyup.enter="doSearch"> </form-input>
				<!-- PRO ID -->
				<form-input placeholder="Identifiant professionnel (RPPS, ADELI, ...)" v-model="form.pro_id" @keyup.enter="doSearch"> </form-input>
				<!-- DR -->
				<form-select
					:items="page.props.admin.users"
					placeholder="Délégué(e) régional(le)"
					@valueChange="form.dr_id = $event"
					:value="form.dr_id"
					@keyup.enter="doSearch">
					<template v-slot:icon>
						<i class="fas fa-caret-down"></i>
					</template>
				</form-select>
				<!-- SKILLS -->
				<h3 class="text-lg border-b-2 mt-2 col-span-2">Profession(s)</h3>
				<!-- DROPDOWN ADD SKILL -->
				<ui-dropdown ref="dropdownTest" class="col-span-2">
					<template #content>
						<form-input placeholder="Recherche" v-model="searchSkills" class="w-full border-none"> </form-input>
						<div
							v-for="skill in searchSkill"
							:key="skill.id"
							class="p-3 text-center hover:bg-slate-500 hover:text-white cursor-pointer"
							@click="skillAdd(skill)"
							data-trigger="close">
							{{ skill.name }}
						</div>
					</template>
					<template v-slot:trigger>
						<ui-button class="w-full">
							<template v-slot:icon>
								<i class="fas fa-plus-circle"></i>
							</template>
							<template v-slot:text>Ajouter</template>
						</ui-button>
					</template>
				</ui-dropdown>
				<!-- SKILL LIST -->
				<div class="flex flex-col gap-3 justify-between col-span-2">
					<div class="flex flex-wrap gap-1" v-if="form.skills.length > 0">
						<div
							v-for="skill in form.skills"
							:key="skill"
							class="text-slate-700 bg-slate-50 border border-blue-500 rounded-md p-2 px-5 whitespace-nowrap relative overflow-hidden cursor-pointer hover:border-red-400 group"
							@click.prevent="skillDelete(skill)">
							{{ page.props.str.statuses.find((element) => element.id == skill)?.name }}
							<div
								class="absolute top-0 left-0 bg-red-500 w-full h-full hidden group-hover:flex items-center justify-center text-white">
								<i class="fas fa-trash"></i>
							</div>
						</div>
					</div>
				</div>
				<!-- ACTIVITIES -->
				<h3 class="text-lg border-b-2 mt-2 col-span-2">Activité(s)</h3>
				<!-- DROPDOWN ADD ACTIVITY -->
				<ui-dropdown ref="dropdownTest" class="col-span-2">
					<template #content>
						<form-input placeholder="Recherche" v-model="searchActivities" class="w-full border-none"> </form-input>
						<div
							v-for="activity in searchActivity"
							:key="activity.id"
							class="p-3 text-center hover:bg-slate-500 hover:text-white cursor-pointer"
							@click="activityAdd(activity)"
							data-trigger="close">
							{{ activity.name }}
						</div>
					</template>
					<template v-slot:trigger>
						<ui-button class="w-full">
							<template v-slot:icon>
								<i class="fas fa-plus-circle"></i>
							</template>
							<template v-slot:text>Ajouter</template>
						</ui-button>
					</template>
				</ui-dropdown>
				<!-- ACTIVITIES LIST -->
				<div class="flex flex-col gap-3 justify-between col-span-2">
					<div class="flex flex-wrap gap-1" v-if="form.activities.length > 0">
						<div
							v-for="activity in form.activities"
							:key="activity"
							class="text-slate-700 bg-slate-50 border border-blue-500 rounded-md p-2 px-5 whitespace-nowrap relative overflow-hidden cursor-pointer hover:border-red-400 group"
							@click.prevent="activityDelete(activity)">
							{{ page.props.str.statuses.find((element) => element.id == activity)?.name }}
							<div
								class="absolute top-0 left-0 bg-red-500 w-full h-full hidden group-hover:flex items-center justify-center text-white">
								<i class="fas fa-trash"></i>
							</div>
						</div>
					</div>
				</div>
				<!-- CONTACT PREFERENCE -->
				<form-checkbox
					:items="page.props.str.statuses.filter((status) => status.type == 'communication')"
					v-model="form.infos.communication"
					label="Modes de communication"
					class="col-span-2">
				</form-checkbox>
				<!-- VISIT PREFERENCE -->
				<form-radio
					v-if="page.props.str.statuses.filter((status) => status.type == 'visit').length > 0"
					:items="page.props.str.statuses.filter((status) => status.type == 'visit')"
					v-model="form.infos.visit"
					label="Type de visite"
					class="col-span-2">
				</form-radio>
				<ui-button @click="doSearch" class="col-span-2 mt-3 font-bold border-2" position="center">
					<template v-slot:text>Rechercher</template>
				</ui-button>
			</form>
		</div>
		<div v-else class="h-full w-full flex items-center justify-center text-2xl">
			<i class="fas fa-circle-notch fa-spin"></i>
		</div>
	</ui-modal>
</template>

<script setup>
	import { ref, computed, onMounted } from 'vue';
	import { usePage, router } from '@inertiajs/vue3';
	import { toast } from 'vue3-toastify';

	const page = usePage();

	const props = defineProps({
		searchForm: {
			type: Object,
			default: () => ({}),
		},
	});

	const emit = defineEmits(['toggle']);

	const loading = ref(false);
	const searchSkills = ref('');
	const searchActivities = ref('');

	const form = ref({
		name: null,
		address: null,
		pro_id: null,
		skills: [],
		activities: [],
		infos: {
			communication: [],
			visit: [],
		},
		dr_id: null,
		structure: null,
	});

	const searchSkill = computed(() => {
		if (searchSkills.value) {
			return page.props.str.statuses.filter((w) => w.type === 'skill' && w.name.toLowerCase().includes(searchSkills.value.toLowerCase()));
		}
		return page.props.str.statuses.filter((w) => w.type === 'skill');
	});

	const searchActivity = computed(() => {
		if (searchActivities.value) {
			return page.props.str.statuses.filter(
				(w) => w.type === 'activity' && w.name.toLowerCase().includes(searchActivities.value.toLowerCase()),
			);
		}
		return page.props.str.statuses.filter((w) => w.type === 'activity');
	});

	const doSearch = () => {
		loading.value = true;
		router.get(route('contrats.index'), { params: form.value });
	};

	const skillAdd = (skill) => {
		if (form.value.skills.includes(skill.id)) {
			toast.error('La profession est déjà présente dans la liste');
		} else {
			form.value.skills.push(skill.id);
		}
	};

	const skillDelete = (skill) => {
		form.value.skills = form.value.skills.filter((element) => element !== skill);
	};

	const activityAdd = (activity) => {
		if (form.value.activities.includes(activity.id)) {
			toast.error("L'activité est déjà présente dans la liste");
		} else {
			form.value.activities.push(activity.id);
		}
	};

	const activityDelete = (activity) => {
		form.value.activities = form.value.activities.filter((element) => element !== activity);
	};

	onMounted(() => {
		if (Object.keys(props.searchForm).length > 0) {
			form.value = { ...props.searchForm };
		}
	});
</script>
